import type { Config } from 'driver.js'

export const TOUR_THEME = {
  overlayColor: '#003d36',
  overlayOpacity: 0.46,
  stagePadding: 10,
  stageRadius: 18,
} satisfies Pick<Config, 'overlayColor' | 'overlayOpacity' | 'stagePadding' | 'stageRadius'>
